import {useEffect} from 'react';
import {useStore} from '@store/appStore';
import { useI18n } from '@i18n/useI18n';
import DefaultTemplate from '@templates/DefaultTemplate';
import {Wrapper} from '@components/GridCards/Common.styled';
import Redeem from '@components/Redeem';
import StudentAdmin from "@components/StudentAdmin";

export const StudentAdminPage = () => {
    const { settings } = useStore();

    const i18n = useI18n();


    useEffect(() => {

        window.scrollTo(0,0)
    },[])


    return (
        <DefaultTemplate>
            <Wrapper>
                <StudentAdmin/>
            </Wrapper>
        </DefaultTemplate>
    );
};

export default StudentAdminPage;